module.exports = __webpack_public_path__ + "img/debt_client.a4f4f314.png";